import request from '@/utils/request'

export function getPageList(data) {
  return request({
    url: 'publish/getPageList',
    method: 'post',
    data,
  })
}

export function save(data) {
  return request({
    url: 'publish/Save',
    method: 'post',
    data,
  })
}

export function del(data) {
  return request({
    url: 'publish/Delete',
    method: 'post',
    data,
  })
}
